import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="empty">
      <b>
        <FormattedMessage id="notFound.title" defaultMessage="There is nothing at this address" description="404 title" />
      </b>
      <Link to="/">
        <FormattedMessage id="notFound.back" defaultMessage="Back to Pulse" description="404 link home" />
      </Link>
    </div>
  );
}
